import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/rates/$country')({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: '/$lang/rates/$country',
      params: { lang: await getPreferredLang(), country: params.country },
      replace: true,
    })
  },
})
